import { useAtom } from 'jotai';
import * as state from '../state';
import { SUPPORT_ERROR_MESSAGE } from '@/constants';
import Button from '@mui/material/Button';
import { GenericConfirmationDialog } from '@/components/Analysis/shared/GeneriConfirmationDialog';

export const PipeSpecUploadErrorDialog = () => {
  const [pipeSpecUploadState, setPipeSpecUploadState] = useAtom(state.pipeSpecUploadState);

  const onClose = () => {
    setPipeSpecUploadState((previous) => ({
      ...previous,
      error: undefined,
      inputCsv: undefined,
      state: 'idle',
    }));
  };

  return (
    <GenericConfirmationDialog
      open={pipeSpecUploadState.state === 'generic-error'}
      onClose={onClose}
      title="Validation Error"
      description={
        typeof pipeSpecUploadState.error?.message === 'string'
          ? pipeSpecUploadState.error?.message
          : SUPPORT_ERROR_MESSAGE
      }
      body={<></>}
    >
      <Button variant="contained" onClick={onClose}>
        Got it
      </Button>
    </GenericConfirmationDialog>
  );
};
